import React, { useId } from "react";
import { ArrowDown, ArrowUpRight, Check, Mail, Sparkles } from "lucide-react";
import "../styles/product-art-additions.css";

export function KineticArt() {
  return (
    <div className="kinetic-scene">
      <div className="kinetic-table">
        <div className="kinetic-table-title"><span className="kinetic-mark" /> Prospect research <span>3 prospects</span></div>
        <div className="kinetic-table-head"><span>Company</span><span>Research</span><span>Next step</span></div>
        {["Northstar", "Fieldwork", "Daybreak"].map((name, i) => (
          <div className="kinetic-table-row" key={name}>
            <span><i style={{ "--company-color": ["#e6c0ac", "#b9cee5", "#d3ccdf"][i] }}>{name[0]}</i>{name}</span>
            <span><Check size={12} /> Ready</span>
            <span className="kinetic-draft"><Mail size={12} /> Draft</span>
          </div>
        ))}
      </div>
      <div className="kinetic-connection"><span /><ArrowDown size={18} /><span /></div>
      <div className="kinetic-agent"><Sparkles size={22} /><div><span>Use the research.</span><strong>Prepare a message.</strong></div><ArrowUpRight size={22} /></div>
      <div className="kinetic-footnote">Research. Review. Contact.</div>
    </div>
  );
}

export function HapticArt() {
  return (
    <div className="haptic-scene">
      <div className="haptic-touchpad"><span /><span /><span /><i /></div>
      <span className="haptic-caption">Touch, sound, and vibration.</span>
    </div>
  );
}

export function DrawTuneArt() {
  const id = useId().replace(/:/g, "");
  return (
    <div className="tune-scene">
      <div className="tune-caption"><span>Draw lines to make music.</span><span>4-bar loop</span></div>
      <svg className="tune-canvas" viewBox="0 0 420 280" fill="none">
        <defs>
          <pattern id={`${id}-dots`} width="24" height="24" patternUnits="userSpaceOnUse"><circle cx="6" cy="6" r="1" fill="#000" opacity=".13" /></pattern>
          <linearGradient id={`${id}-pink`} x1="0" y1="0" x2="0" y2="1"><stop stopColor="#f3b7b9" /><stop offset=".5" stopColor="#da8993" /><stop offset="1" stopColor="#ad4e65" /></linearGradient>
          <linearGradient id={`${id}-blue`} x1="0" y1="0" x2="0" y2="1"><stop stopColor="#b7cde9" /><stop offset=".5" stopColor="#7b9cca" /><stop offset="1" stopColor="#486b9c" /></linearGradient>
          <linearGradient id={`${id}-gold`} x1="0" y1="0" x2="0" y2="1"><stop stopColor="#f4db9b" /><stop offset=".5" stopColor="#d8b561" /><stop offset="1" stopColor="#ae8036" /></linearGradient>
          <filter id={`${id}-shadow`} x="-10%" y="-20%" width="130%" height="150%"><feDropShadow dx="2" dy="7" stdDeviation="3" floodColor="#493e32" floodOpacity=".17" /></filter>
        </defs>
        <rect width="420" height="280" fill={`url(#${id}-dots)`} />
        <g strokeWidth="13" strokeLinecap="round" filter={`url(#${id}-shadow)`}>
          <path d="M22 168C61 195 57 42 104 63S132 236 184 194S221 39 264 80S294 204 334 152S365 105 398 116" stroke={`url(#${id}-pink)`} />
          <path d="M25 225C74 256 104 112 153 137S201 244 246 198S295 101 334 129S368 219 399 181" stroke={`url(#${id}-blue)`} />
          <path d="M23 124C62 86 90 192 130 167S158 27 208 45S238 168 288 135S358 38 397 72" stroke={`url(#${id}-gold)`} />
        </g>
        <path d="M217 10V270" stroke="#000" opacity=".2" /><circle cx="217" cy="10" r="3" fill="#000" />
      </svg>
      <div className="tune-instruments"><span><i />Piano</span><span><i />Bass</span><span><i />Music box</span><span>+ 3 sounds</span></div>
    </div>
  );
}
